import React, {useState} from "react";
import DeleteOutlineSharpIcon from '@material-ui/icons/DeleteOutlineSharp';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import ChatIcon from '@material-ui/icons/Chat';
import '../css/moodboard-masonry.css';
import {Menu, ListItemIcon, Typography, MenuItem} from '@material-ui/core';
import ReactJWPlayer from 'react-jw-player';

function TileVideo(props) {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = event => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    return <div className={`tile ${props.id}`}>
        {/*<span className='moodboard-item-icon' onClick= { e => props.delete(props.id)}><DeleteOutlineSharpIcon className='moodboard-item-icon'/></span>*/}
        <div className="tile-options">
            <MoreHorizIcon className="btn-tile-options" onClick={handleClick}/>
            <Menu
                anchorEl={anchorEl}
                keepMounted
                open={open}
                onClose={handleClose}
            >
                <MenuItem onClick={e => {
                    setAnchorEl(null);
                    props.view(props.id);
                }}>
                    View Comments
                </MenuItem>
                <MenuItem onClick={e => {
                    setAnchorEl(null);
                    props.delete(props.id);
                }}>
                    Delete
                </MenuItem>
            </Menu>
        </div>
        <ReactJWPlayer
            className="player"
            playerId={props.id.toString()}
            playerScript='https://cdn.jwplayer.com/libraries/s7lNp89j.js'
            file={props.src}
            image={props.image ? props.image.replace("h=630", "h=200").replace("w=1200", "w=350") : null}
        />
        {/* <video className="player" controls>
            <source src={props.src} type="video/mp4"/>
        </video> */}
    </div>
}

export default TileVideo;